import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import IconSvg from './components/IconSvg.vue'
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.component('icon-svg', IconSvg)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
